import { useId } from 'react';

import Icon from 'ms-ui-primitives/Icon';

import type { Props } from '../types';

const TestTask = ({
  color,
  size,
  title,
  titleId,
  aphroditeStyles = [],
}: Props) => {
  const mask1Id = useId();
  const mask2Id = useId();
  return (
    <Icon
      color={color}
      size={size}
      aphroditeStyles={aphroditeStyles}
      title={title}
      titleId={titleId}
    >
      <mask
        id={mask1Id}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="18"
        height="18"
      >
        <mask
          id={mask2Id}
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
        >
          <rect width="20" height="20" fill="#D9D9D9" />
        </mask>
        <g mask={`url(#${mask2Id})`}>
          <path
            d="M15.4167 14.8333V12.9167C15.4167 12.8056 15.375 12.7083 15.2917 12.625C15.2083 12.5417 15.1111 12.5 15 12.5C14.8889 12.5 14.7917 12.5417 14.7083 12.625C14.625 12.7083 14.5833 12.8056 14.5833 12.9167V14.8333C14.5833 14.9444 14.6042 15.0486 14.6458 15.1458C14.6875 15.2431 14.75 15.3333 14.8333 15.4167L16.1042 16.6875C16.1875 16.7708 16.2847 16.8125 16.3958 16.8125C16.5069 16.8125 16.6042 16.7708 16.6875 16.6875C16.7708 16.6042 16.8125 16.5069 16.8125 16.3958C16.8125 16.2847 16.7708 16.1875 16.6875 16.1042L15.4167 14.8333ZM4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V4.16667C2.5 3.70833 2.66319 3.31597 2.98958 2.98958C3.31597 2.66319 3.70833 2.5 4.16667 2.5H15.8333C16.2917 2.5 16.684 2.66319 17.0104 2.98958C17.3368 3.31597 17.5 3.70833 17.5 4.16667V8.33333C17.5 8.56944 17.4201 8.76736 17.2604 8.92708C17.1007 9.08681 16.9028 9.16667 16.6667 9.16667C16.4306 9.16667 16.2326 9.08681 16.0729 8.92708C15.9132 8.76736 15.8333 8.56944 15.8333 8.33333V4.16667H4.16667V15.8333H8.33333C8.56944 15.8333 8.76736 15.9132 8.92708 16.0729C9.08681 16.2326 9.16667 16.4306 9.16667 16.6667C9.16667 16.9028 9.08681 17.1007 8.92708 17.2604C8.76736 17.4201 8.56944 17.5 8.33333 17.5H4.16667ZM4.16667 15.8333V4.16667V9.22917V9.16667V15.8333ZM5.83333 13.3333C5.83333 13.5694 5.91319 13.7674 6.07292 13.9271C6.23264 14.0868 6.43056 14.1667 6.66667 14.1667H8.39583C8.63194 14.1667 8.82986 14.0868 8.98958 13.9271C9.14931 13.7674 9.22917 13.5694 9.22917 13.3333C9.22917 13.0972 9.14931 12.8993 8.98958 12.7396C8.82986 12.5799 8.63194 12.5 8.39583 12.5H6.66667C6.43056 12.5 6.23264 12.5799 6.07292 12.7396C5.91319 12.8993 5.83333 13.0972 5.83333 13.3333ZM5.83333 10C5.83333 10.2361 5.91319 10.434 6.07292 10.5938C6.23264 10.7535 6.43056 10.8333 6.66667 10.8333H10.8333C11.0694 10.8333 11.2674 10.7535 11.4271 10.5938C11.5868 10.434 11.6667 10.2361 11.6667 10C11.6667 9.76389 11.5868 9.56597 11.4271 9.40625C11.2674 9.24653 11.0694 9.16667 10.8333 9.16667H6.66667C6.43056 9.16667 6.23264 9.24653 6.07292 9.40625C5.91319 9.56597 5.83333 9.76389 5.83333 10ZM5.83333 6.66667C5.83333 6.90278 5.91319 7.10069 6.07292 7.26042C6.23264 7.42014 6.43056 7.5 6.66667 7.5H13.3333C13.5694 7.5 13.7674 7.42014 13.9271 7.26042C14.0868 7.10069 14.1667 6.90278 14.1667 6.66667C14.1667 6.43056 14.0868 6.23264 13.9271 6.07292C13.7674 5.91319 13.5694 5.83333 13.3333 5.83333H6.66667C6.43056 5.83333 6.23264 5.91319 6.07292 6.07292C5.91319 6.23264 5.83333 6.43056 5.83333 6.66667ZM15 19.1667C13.8472 19.1667 12.8646 18.7604 12.0521 17.9479C11.2396 17.1354 10.8333 16.1528 10.8333 15C10.8333 13.8472 11.2396 12.8646 12.0521 12.0521C12.8646 11.2396 13.8472 10.8333 15 10.8333C16.1528 10.8333 17.1354 11.2396 17.9479 12.0521C18.7604 12.8646 19.1667 13.8472 19.1667 15C19.1667 16.1528 18.7604 17.1354 17.9479 17.9479C17.1354 18.7604 16.1528 19.1667 15 19.1667Z"
            fill="#1C1B1F"
          />
        </g>
      </mask>
      <g mask={`url(#${mask1Id})`}>
        <rect width="20" height="20" />
      </g>
    </Icon>
  );
};

TestTask.displayName = 'TestTask';

export default TestTask;
